<!-- Loading Skeleton -->
@if (isLoading()) {
  <!-- Search Skeleton -->
  <section class="shrink-0 px-6 py-4">
    <div class="h-12 animate-pulse rounded bg-white/10"></div>
  </section>

  <!-- Accounts Skeleton -->
  <div class="min-h-0 flex-1 space-y-4 overflow-y-auto px-6 py-4">
    <div class="space-y-3 rounded bg-[#0051D8] p-4">
      <div class="h-5 w-3/4 animate-pulse rounded bg-white/20"></div>
      <div class="h-4 w-full animate-pulse rounded bg-white/10"></div>
      <div class="h-4 w-2/3 animate-pulse rounded bg-white/10"></div>
      <div class="mt-4 flex gap-3">
        <div class="h-10 w-32 animate-pulse rounded bg-white/20"></div>
        <div class="h-10 flex-1 animate-pulse rounded bg-white/20"></div>
      </div>
    </div>
    @for (i of [1, 2, 3]; track i) {
      <div class="h-20 animate-pulse space-y-2 rounded bg-white/5 p-4">
        <div class="h-4 w-2/3 animate-pulse rounded bg-white/10"></div>
        <div class="h-3 w-full animate-pulse rounded bg-white/10"></div>
      </div>
    }
  </div>
} @else {
  <!-- Search Section -->
  <section class="shrink-0 px-6 py-4">
    <div
      class="flex items-center gap-3 rounded border border-white/30 bg-[#040B78] px-4 py-3"
    >
      <mat-icon class="text-white/60">search</mat-icon>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Search"
        class="flex-1 bg-transparent text-white placeholder-white/50 outline-none"
        aria-label="Search accounts"
      />
    </div>
  </section>

  @if (switchError()) {
    <div class="shrink-0 bg-red-500/20 px-6 py-3 text-sm text-red-200">
      {{ switchError() }}
    </div>
  }

  <!-- Accounts List -->
  <div class="min-h-0 flex-1 overflow-y-auto">
    <ul class="m-0 list-none p-0">
      @for (account of filteredAccounts(); track account.AccountId; let last = $last) {
        <li [ngClass]="{ 'border-b border-white/10': !last }">
          <button
            type="button"
            (click)="onAccountSelect(account.AccountId)"
            [disabled]="isSwitching()"
            [ngClass]="{
              'bg-[#0051D8]': account.IsActive,
              'hover:bg-blue-600': account.IsActive,
              'border-b border-blue-600': account.IsActive,
              'hover:bg-[#003A99]': !account.IsActive,
              'opacity-60': isSwitching(),
            }"
            class="w-full cursor-pointer px-6 py-4 text-left text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white disabled:cursor-not-allowed"
          >
            <div class="flex items-center justify-between gap-3">
              <div class="text-base font-semibold">
                {{ account.Account.Name }}
              </div>
              @if (account.AccountId === defaultAccountId()) {
                <span
                  class="inline-flex items-center rounded-full border border-white/20 bg-white/10 px-2 py-0.5 text-[10px] font-semibold tracking-[0.08em] text-blue-100 uppercase"
                >
                  Default
                </span>
              }
            </div>
            <div class="mt-2 text-sm text-white/95">
              {{ account.FormattedBillingAddress }}
            </div>
          </button>
        </li>
      }
    </ul>
  </div>
}
